import { NgModule } from '@angular/core';
import { NpFullpageDirective, AnchorLinkDirective } from './np-fullpage.directive';

@NgModule({
  imports: [],
  declarations: [NpFullpageDirective, AnchorLinkDirective],
  exports: [NpFullpageDirective, AnchorLinkDirective]
})
export class NewplaFullpageModule { }
